import { render, staticRenderFns } from "./configContent.vue?vue&type=template&id=3a7a42a0&scoped=true"
import script from "./configContent.vue?vue&type=script&lang=js"
export * from "./configContent.vue?vue&type=script&lang=js"
import style0 from "./configContent.vue?vue&type=style&index=0&id=3a7a42a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a42a0",
  null
  
)

export default component.exports